export default __webpack_public_path__ + "static/media/1597.4841ce98.png";